import * as React from 'react';
import AppCore from './AppCore';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import { RootEssentialsProvider } from '@wix/fe-essentials-standalone/react';
import { BiContextProvider } from '../../context/BiContext';
import { HttpClientProvider } from '@wix/fe-essentials/react';
import { httpClient } from '../../utils/httpClient';
import { BrowserRouter } from 'react-router-dom';
import { APP_BASE_ROUTE } from '../../constants/routes';
import { WixDesignSystemProvider } from '@wix/design-system';
import { TemplatesContextProvider } from '../../context/TemplatesContext';
import { NotificationsProvider } from '../../context/NotificationsContext';
import '@wix/design-system/styles.global.css';
import { ReusableProvider } from 'reusable';
import { AppLoader } from './AppLoader';
import { createEssentials } from '@wix/fe-essentials-standalone';
import { initPanoramaClient } from '../../services/panoramaClient';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const i18n = initI18n({
  locale: window.__LOCALE__,
  messages: window.__MESSAGES__,
});
const standaloneEssentials = createEssentials({
  experiments: { scopes: ['app-templates-page'] },
  environment: {
    language: window.__LOCALE__,
    artifactId: '',
    version: '',
  },
  errorHandler: {
    biDefaultsOverrides: {
      app_id: 'app-templates-page',
      hostingEnvironment: 'app-templates-page',
    },
  },
});
const panoramaClient = initPanoramaClient();

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <React.Suspense fallback={<AppLoader />}>
      <I18nextProvider i18n={i18n}>
        <RootEssentialsProvider
          essentials={{ ...standaloneEssentials, panoramaClient }}
        >
          <BiContextProvider>
            <HttpClientProvider value={httpClient}>
              <QueryClientProvider client={queryClient}>
                <BrowserRouter basename={APP_BASE_ROUTE}>
                  <WixDesignSystemProvider
                    features={{ newColorsBranding: true }}
                  >
                    <ReusableProvider>
                      <TemplatesContextProvider>
                        <NotificationsProvider>
                          <AppCore />
                        </NotificationsProvider>
                      </TemplatesContextProvider>
                    </ReusableProvider>
                  </WixDesignSystemProvider>
                </BrowserRouter>
              </QueryClientProvider>
            </HttpClientProvider>
          </BiContextProvider>
        </RootEssentialsProvider>
      </I18nextProvider>
    </React.Suspense>
  );
};

export default App;
